(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["da-artist-tombstones"] && !Shopify.designMode) return;
  try {
    
  function selectArtistSeason(archive, season) {
    archive.querySelectorAll('[data-archive-group]').forEach(group => {
      group.hidden = group.dataset.archiveGroup !== season;
    });
    archive.querySelectorAll('[data-archive-season]').forEach(link => {
      if (link.dataset.archiveSeason === season) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }
  function initializeArtistArchives() {
    document.querySelectorAll('.da-archive').forEach(archive => {
      const selected = [...archive.querySelectorAll('[data-archive-season]')].find(link => link.hash === location.hash);
      selectArtistSeason(archive, selected ? selected.dataset.archiveSeason : 'Spring 2026');
      archive.querySelectorAll('.da-archive__plot').forEach(plot => {
        if (plot.dataset.productsInitialized) return;
        plot.dataset.productsInitialized = 'true';
        const details = plot.querySelector('.da-archive__contributions');
        const track = plot.querySelector('.da-archive__product-track');
        if (!track.children.length) { details.hidden = true; return; }
        const arrows = plot.querySelector('.da-archive__arrows');
        arrows.hidden = track.children.length < 2;
        const update = () => {
          arrows.querySelector('[data-product-step="-1"]').disabled = track.scrollLeft <= 2;
          arrows.querySelector('[data-product-step="1"]').disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        track.addEventListener('scroll', update, { passive: true });
        new ResizeObserver(update).observe(track);
        plot.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') details.open = true;
        });
        plot.addEventListener('pointerleave', () => {
          if (!details.dataset.pinned && !plot.contains(document.activeElement)) details.open = false;
        });
        details.querySelector('summary').addEventListener('click', () => {
          if (details.open) delete details.dataset.pinned;
          else details.dataset.pinned = 'true';
        });
        plot.addEventListener('focusin', event => {
          if (event.target.matches('.da-archive__stone')) details.open = true;
        });
        plot.addEventListener('focusout', event => {
          if (!plot.contains(event.relatedTarget) && !details.dataset.pinned && !plot.matches(':hover')) details.open = false;
        });
        plot.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            delete details.dataset.pinned;
            details.querySelector('summary').focus();
            details.open = false;
          }
        });
      });
    });
  }
  document.addEventListener('click', event => {
    const arrow = event.target.closest('[data-product-step]');
    if (arrow) {
      const track = arrow.closest('.da-archive__products').querySelector('.da-archive__product-track');
      track.scrollBy({ left: Number(arrow.dataset.productStep) * (track.clientWidth + 12), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      return;
    }
    const link = event.target.closest('[data-archive-season]');
    if (!link) return;
    event.preventDefault();
    selectArtistSeason(link.closest('.da-archive'), link.dataset.archiveSeason);
    history.replaceState(null, '', link.hash);
  });
  document.addEventListener('shopify:section:load', initializeArtistArchives);
  document.addEventListener('shopify:block:select', event => {
    const group = event.target.closest('[data-archive-group]');
    if (group) selectArtistSeason(group.closest('.da-archive'), group.dataset.archiveGroup);
  });
  window.addEventListener('hashchange', initializeArtistArchives);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeArtistArchives);
  else initializeArtistArchives();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
